export default class ShopifyObject {
  /**
   * @param {*} id
   * @param {*} payload
   */
  constructor(id) {
    this._id = id || 0;
    this._hasChanged = false;
  }

  /**
   * @returns {boolean}
   */
  get hasChanged() {
    return this._hasChanged;
  }

  /**
   * @param {boolean} value
   */
  set hasChanged(value) {
    this._hasChanged = value;
  }

  /**
   * @returns {number}
   */
  get id() {
    return this._id;
  }
}
